import React, { useCallback, useEffect, useState, useContext } from 'react'
import makeStyles from '@mui/styles/makeStyles';

import Divider from '@mui/material/Divider'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'

import {
  ILayout_Editor,
  ILayout_Cell_Props_File,
} from '@kaidam/fc-shared/src/types/layout'

import {
  IForm_File,
} from '@kaidam/fc-shared/src/types/schema/form'

import TinyButton from '../../widgets/TinyButton'
import icons from '../../../icons'

import FileChooser from '../../filestore/FileChooser'

import EditorContext from '../EditorContext'

import {
  isFolder,
} from '@kaidam/fc-shared/src/utils/file'

const EditIcon = icons.imageSearch

/*

  EDITOR

*/

const FileEditor: ILayout_Editor<ILayout_Cell_Props_File> = ({
  cell,
  triggerEdit,
  onSetEditing,
  onDeselect,
  onChange,
}) => {

  const editorContext = useContext(EditorContext)

  const [ choosing, setChoosing ] = useState(false)

  const {
    file,
    title = '',
  } = cell.data

  const onEdit = useCallback(() => {
    setChoosing(true)
    onSetEditing(true)
  }, [])

  const onCancelEdit = useCallback(() => {
    setChoosing(false)
    onSetEditing(false)
    onDeselect()
  }, [])

  const onUpdateTitle = useCallback((e: any) => {
    onChange({
      title: e.target.value,
    })
  }, [])

  const onChooseFile = useCallback(async (file: IForm_File) => {
    let update: Partial<ILayout_Cell_Props_File> = {
      title,
      file,
    }
    onChange(update)
    setChoosing(false)
    onSetEditing(false)
  }, [
    title,
  ])

  useEffect(() => {
    if(triggerEdit) onEdit()
  }, [
    triggerEdit,
  ])

  return (
    <Box>
      <TinyButton
        size="small"
        color="primary"
        sx={{
          my: 1,
        }}
        onClick={ onEdit }
      >
        Find File
      </TinyButton>
      <Divider
        sx={{
          my: 1,
        }}
       />
      <Box
        className='settingsRow'
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          '& .shrink': {
            flexGrow: 0,
            mx: 1,
          },
          '& .grow': {
            flexGrow: 1,
            '& input': {
              textAlign: 'right',
            }
          },
          '& .caption': {
            flexGrow: 1,
            mt: 1,
            mx: 1,
          },
        }}
        onMouseEnter={ () => {
          onSetEditing(true)
        }}
        onMouseLeave={ () => {
          onSetEditing(false)
        }}
      >
        <Box className="title">
          <TextField
            fullWidth
            label="Title"
            value={ title }
            onChange={ onUpdateTitle }
          />
        </Box>
      </Box>
      {
        choosing && (
          <FileChooser
            publicMode={ editorContext.options.publicFiles ? true : false }
            sharedMode={ editorContext.options.sharedFiles ? true : false }
            selectFilter={ (filename) => isFolder(filename) ? false : true }
            onChoose={ onChooseFile }
            onClose={ onCancelEdit }
          />
        )
      }
    </Box>
  )
}

export default FileEditor